import { useCallback, useMemo } from "react";
import { useInvestmentEntityLookupLazyQuery } from "#graphql/supergraphHooks";
import { toDbId } from "#utils/globalId";

export type AssignableEntity = { id: string; name: string };

export type UseAssignableEntitiesReturn = {
  search: (searchTerm: string) => void;
  options: AssignableEntity[];
  loading: boolean;
};

export function useAssignableEntities(
  arenaId: number | undefined,
): UseAssignableEntitiesReturn {
  const [run, { data, loading }] = useInvestmentEntityLookupLazyQuery({
    fetchPolicy: "network-only",
  });

  const search = useCallback(
    (searchTerm: string) => {
      if (arenaId === undefined || !searchTerm.trim()) {
        return;
      }
      void run({
        variables: { search: searchTerm },
        context: { clientName: "staff", arenaId },
      });
    },
    [run, arenaId],
  );

  const options = useMemo<AssignableEntity[]>(
    () =>
      (data?.investmentEntities?.edges ?? []).map(({ node }) => ({
        id: String(toDbId(node.id)),
        name: node.name,
      })),
    [data],
  );

  return { search, options, loading };
}
